import langs from './langs';
import deAccount from '../../../bin-kfn/json/lang/app/de/account.json';

Object.assign(langs['de/account'], deAccount);

export default langs;
